import React, { useRef, useEffect, useImperativeHandle, forwardRef } from "react";
import { Button } from "../ui/button";
import { Icon } from "@iconify/react";
import Common from "../../helper/common";
import Utility from "../../helper/utilityHelper";

const POSReceipt = forwardRef(({
    order = {},
    title = "PlayPro",
    subtitle = "POS Order Receipt",
    showPrintButton = true,
    showViewButton = false,
    buttonText = "Print Receipt",
    buttonIcon = "heroicons:printer",
    buttonSize = "sm",
    buttonVariant = "outline",
    onBeforePrint = null,
    onAfterPrint = null,
    autoPrint = false,
}, ref) => {
    const printRef = useRef();

    // Auto-print functionality
    useEffect(() => {
        if (autoPrint && order && Object.keys(order).length > 0) {
            const timer = setTimeout(() => {
                handlePrint();
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [autoPrint, order]);

    // Expose print function to parent component
    useImperativeHandle(ref, () => ({
        print: handlePrint,
        view: handleView
    }));





    const handleView = () => {
        const printContent = printRef.current;
        if (!printContent) {
            console.error("Print content not available");
            return;
        }

        const winView = window.open("", "_blank", "width=580,height=800,scrollbars=yes,resizable=yes");
        if (!winView) {
            console.error("Failed to open view window. Please check if popup blocker is enabled.");
            alert("View popup was blocked. Please allow popups for this site or try again.");
            return;
        }

        winView.document.write(getHTMLContent(printContent.innerHTML));
        try {
            winView.document.close();
            winView.focus();
        } catch (error) {
            console.error("Failed to write to view window:", error);
            if (winView) winView.close();
        }
    };

    const handlePrint = () => {
        if (onBeforePrint) onBeforePrint();

        const printContent = printRef.current;
        if (!printContent) {
            console.error("Print content not available");
            return;
        }

        const winPrint = window.open("", "_blank", "width=580,height=800,scrollbars=yes,resizable=yes");
        if (!winPrint) {
            console.error("Failed to open print window. Please check if popup blocker is enabled.");
            return;
        }

        winPrint.document.write(getHTMLContent(printContent.innerHTML));
        try {
            winPrint.document.close();
            winPrint.focus();

            winPrint.onafterprint = () => {
                if (onAfterPrint) onAfterPrint();
                winPrint.close();
            };

            setTimeout(() => {
                try {
                    winPrint.print();
                } catch (error) {
                    console.error("Print error:", error);
                    winPrint.close();
                }
            }, 500);
        } catch (error) {
            console.error("Failed to write to print window:", error);
            if (winPrint) winPrint.close();
        }
    };

    const getHTMLContent = (bodyContent) => `
    <html>
      <head>
        <title>${title} - ${subtitle}</title>
        <style>
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          body {
            font-family: 'Arial', sans-serif;
            line-height: 1.3;
            color: #000;
            background: white;
            padding: 8px;
            margin: 0;
            font-size: 12px;
          }
          
                     .pos-receipt-container {
             max-width: 360px;
             margin: 0 auto;
             background: white;
             border: 2px solid #000;
             padding: 0;
           }
           
           .pos-header {
             background: white;
             color: #000;
             padding: 8px 12px;
             text-align: center;
             border-bottom: 2px solid #000;
           }
           
           .pos-title {
             font-size: 16px;
             font-weight: bold;
             margin-bottom: 2px;
             text-transform: uppercase;
           }
           
           .pos-subtitle {
             font-size: 12px;
             margin-bottom: 4px;
             font-weight: normal;
           }
           
           .pos-order-info {
             font-size: 10px;
             margin-top: 4px;
           }
           
           .pos-content {
             padding: 8px 12px;
             background: white;
           }
           
           .pos-info-row {
             display: flex;
             justify-content: space-between;
             padding: 2px 0;
             border-bottom: 1px dotted #ccc;
           }
          
          .pos-info-label {
            font-weight: normal;
            color: #000;
            font-size: 12px;
          }
          
          .pos-info-value {
            font-weight: bold;
            color: #000;
            font-size: 12px;
          }
          
                     .pos-items-section {
             margin: 6px 0;
           }
           
           .pos-items-header {
             text-align: center;
             font-weight: bold;
             font-size: 12px;
             padding: 4px 0;
             border-top: 2px solid #000;
             border-bottom: 1px solid #000;
             background: #f8f8f8;
           }
          
                                 .pos-items-table {
             width: 100%;
             border-collapse: collapse;
             margin: 6px 0;
           }
           
           .pos-items-table th {
             background: #f0f0f0;
             border: 1px solid #000;
             padding: 4px 6px;
             font-size: 11px;
             font-weight: bold;
             text-align: left;
           }
           
           .pos-items-table td {
             border: none;
             padding: 3px 6px;
             font-size: 10px;
             background: white;
           }
          
          .pos-item-name {
            text-align: left;
            font-weight: bold;
            max-width: 120px;
            word-wrap: break-word;
          }
          
          .pos-item-qty {
            text-align: center;
            width: 40px;
            font-weight: bold;
          }
          
          .pos-item-price {
            text-align: right;
            width: 70px;
          }
          
          .pos-item-total {
            text-align: right;
            width: 70px;
            font-weight: bold;
          }
          
          .pos-totals-section {
            margin: 6px 0;
            border-top: 2px solid #000;
            padding-top: 4px;
          }
          
          .pos-total-row {
            display: flex;
            justify-content: space-between;
            padding: 2px 0;
            font-size: 12px;
          }
          
          .pos-total-row.final {
            border-top: 1px solid #000;
            border-bottom: 2px solid #000;
            padding: 4px 0;
            font-weight: bold;
            font-size: 14px;
          }
          
          .pos-footer {
            background: white;
            padding: 8px 12px;
            text-align: center;
            border-top: 2px solid #000;
            font-size: 9px;
          }
          
          .pos-thank-you {
            font-weight: bold;
            margin-bottom: 6px;
            font-size: 12px;
          }
          
          .pos-company {
            margin-bottom: 4px;
          }
          
          .pos-datetime {
            margin-top: 6px;
            font-size: 9px;
          }
          
          .divider {
            height: 2px;
            background: #000;
            margin: 8px 0;
          }
          
          @media print {
            body {
              padding: 0;
              margin: 0;
              background: white !important;
            }
            
            .pos-receipt-container {
              border: 2px solid #000 !important;
              max-width: none;
              margin: 0;
            }
            
            .pos-header, .pos-content, .pos-footer {
              background: white !important;
              color: #000 !important;
            }
            
            .pos-items-table th {
              border: 1px solid #000 !important;
              background: white !important;
            }
            
            .pos-items-table td {
              border: none !important;
              background: white !important;
            }
            
            .pos-items-header {
              background: #f8f8f8 !important;
            }
          }
        </style>
      </head>
      <body>
        ${bodyContent}
      </body>
    </html>
  `;

    if (!order || Object.keys(order).length === 0) {
        return (
            <div className="flex items-center gap-2">
                {showPrintButton && (
                    <Button
                        variant={buttonVariant}
                        size={buttonSize}
                        disabled
                        className="flex items-center gap-1 opacity-50"
                    >
                        <Icon icon={buttonIcon} width={14} />
                        <span className="text-xs">{buttonText}</span>
                    </Button>
                )}
            </div>
        );
    }



    return (
        <>
            <div className="flex items-center gap-2">
                {showViewButton && (
                    <Button
                        variant={buttonVariant}
                        size={buttonSize}
                        onClick={handleView}
                        className="flex items-center gap-1"
                    >
                        <Icon icon="heroicons:eye" width={14} />
                        <span className="text-xs">View</span>
                    </Button>
                )}
                {showPrintButton && (
                    <Button
                        variant={buttonVariant}
                        size={buttonSize}
                        onClick={handlePrint}
                        className="flex items-center gap-1"
                    >
                        <Icon icon={buttonIcon} width={14} />
                        <span className="text-xs">{buttonText}</span>
                    </Button>
                )}
            </div>

            <div ref={printRef} style={{ display: "none" }}>
                <div className="pos-receipt-container">
                    {/* Header */}
                    <div className="pos-header">
                        <div className="pos-title">{title}</div>
                        <div className="pos-subtitle">{subtitle}</div>

                    </div>

                    {/* Content */}
                    <div className="pos-content">
                        {/* Order Information */}

                        <div className="pos-info-row">
                            <span className="pos-info-label">Order Number:</span>
                            <span className="pos-info-value">{order.ref_no}</span>
                        </div>

                        <div className="pos-info-row">
                            <span className="pos-info-label">Order Date:</span>
                            <span className="pos-info-value">{order.createdon ? Common.Utility.ConvertTime(order.createdon) : "N/A"}</span>
                        </div>

                        <div className="pos-info-row">
                            <span className="pos-info-label">Customer:</span>
                            <span className="pos-info-value">{order.customerName || "Walk-in Customer"}</span>
                        </div>

                        {/* <div className="pos-info-row">
                            <span className="pos-info-label">Payment Status:</span>
                            <span className="pos-info-value">{getPaymentStatusLabel(order.payment_status)}</span>
                        </div> */}
                        {/* 
                        <div className="pos-info-row">
                            <span className="pos-info-label">Order Status:</span>
                            <span className="pos-info-value">{getOrderStatusLabel(order.status)}</span>
                        </div> */}

                        {/* Items Section */}
                        <div className="pos-items-section">
                            <div className="pos-items-header">ORDER ITEMS</div>
                            {order.items && order.items.length > 0 ? (
                                <table className="pos-items-table">
                                    <thead>
                                        <tr>
                                            <th className="pos-item-name">Item</th>
                                            <th className="pos-item-qty">Qty</th>
                                            <th className="pos-item-price">Unit Price</th>
                                            <th className="pos-item-total">Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {order.items.map((item, index) => (
                                            <tr key={index}>
                                                <td className="pos-item-name">
                                                    <div style={{ fontWeight: 'bold' }}>
                                                        {item.productName || item.name || `Product #${item.productid || item.id}`}
                                                    </div>
                                                    {item.description && (
                                                        <div style={{ fontSize: '10px', color: '#666', marginTop: '2px' }}>
                                                            {item.description}
                                                        </div>
                                                    )}
                                                </td>
                                                <td className="pos-item-qty">{item.quantity}</td>
                                                <td className="pos-item-price">PKR {item.price?.toFixed(0) || "0"}</td>
                                                <td className="pos-item-total">PKR {item.total?.toFixed(0) || "0"}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : (
                                <div style={{ padding: '20px', textAlign: 'center', background: '#f9f9f9', border: '1px solid #ddd' }}>
                                    <strong>No items found</strong><br />
                                    <small>Items count: {order.items ? order.items.length : 'undefined'}</small>
                                </div>
                            )}
                        </div>



                        {/* Totals Section */}
                        <div className="pos-totals-section">
                            <div className="pos-total-row">
                                <span>Subtotal:</span>
                                <span>PKR {order.total_amount?.toFixed(0) || "0"}</span>
                            </div>

                            {order.discount > 0 && (
                                <div className="pos-total-row">
                                    <span>Discount:</span>
                                    <span>-PKR {order.discount?.toFixed(0)}</span>
                                </div>
                            )}

                            <div className="pos-total-row final">
                                <span>Net Total:</span>
                                <span>PKR {order.net_amount?.toFixed(0) || "0"}</span>
                            </div>

                            <div className="pos-total-row">
                                <span>Received Amount:</span>
                                <span>PKR {order.received_amount?.toFixed(0) || "0"}</span>
                            </div>

                            {order.remaining_amount > 0 && (
                                <div className="pos-total-row">
                                    <span>Remaining Amount:</span>
                                    <span>PKR {order.remaining_amount?.toFixed(0)}</span>
                                </div>
                            )}
                        </div>

                        {/* Notes */}
                        {/* {order.note && (
                            <>
                                <div className="divider"></div>
                                <div className="pos-info-row">
                                    <span className="pos-info-label">Notes:</span>
                                </div>
                                <div style={{ padding: '4px 0', fontSize: '11px' }}>
                                    {order.note}
                                </div>
                            </>
                        )} */}
                    </div>

                    {/* Footer */}
                    <div className="pos-footer">
                        <div className="pos-thank-you">Thank you for your business!</div>
                        <div className="pos-company">Powered by PlayPro</div>
                        <div className="pos-datetime">
                            Printed on: {Common.moment().utcOffset(300).format("DD/MM/YYYY hh:mm A")}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

export default POSReceipt;
